import React from "react";
import { useContext } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const statusBarContext = React.createContext({});

export function StatusBarContextProvider({ children }) {
  const [barStatus, setBarStatus] = useState(false);

  return (
    <statusBarContext.Provider value={{ barStatus, setBarStatus }}>
      {children}
    </statusBarContext.Provider>
  );
}

export function useStatusBar() {
  const { barStatus, setBarStatus } = useContext(statusBarContext);
  const navigate = useNavigate();

  function handleCloseBar(path) {
    setBarStatus(false);
    navigate(path);
  }
  function handleOpenBar() {
    setBarStatus(true);
  }

  return {
    barStatus,
    setBarStatus,
    handleCloseBar,
    handleOpenBar,
  };
}
